import LinkifyIt from "linkify-it";
import type { ReactNode } from "react";
import type { LinkProps as RouterLinkProps } from "react-router-dom";

import { SmartLink } from "@/ui-modules/core/SmartLink.tsx";

export interface LinkProps extends RouterLinkProps {
  forceExternal?: boolean;
  setExternal?: (isExternal: boolean) => void;
  tooltip?: string;
  forceTooltip?: boolean;
}

export const parseSmartLink = (text?: string): ReactNode | undefined => {
  if (!text) return text;

  const linkify = new LinkifyIt();
  const matches = linkify.match(text);

  // No links found inside the text.
  if (matches == null) return text;

  const JSXParts: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of matches) {
    // This is just text before the match
    JSXParts.push(text.slice(lastIndex, match.index));
    lastIndex = match.lastIndex;

    // We replace the detected link by a <SmartLink>
    JSXParts.push(
      <SmartLink to={match.url} tooltip={match.text}>
        {match.text}
      </SmartLink>,
    );
  }

  // Just add the remaining text
  JSXParts.push(text.slice(lastIndex));

  return JSXParts;
};
